import { Modal } from 'bootstrap'
import { datepicker } from 'flatpickr-prefabs'
import dayjs from 'dayjs'
import moment from 'moment'
import { ddlGenericInitialise } from 'slim-select-prefabs'
import { popoverInitialise } from '../General/utils'

function addDays(dateObj: Date, numDays: number) {
	return dateObj.setDate(dateObj.getDate() + numDays)
}
const setDateRangeOption = (ddlDateRange: HTMLSelectElement, value: string) => {
	const dateArray: Array<ddlDateRangeOption> = new Array()
	// let dateArray = ddlDateRangeOption[]
	Array.from(ddlDateRange.options).forEach((element) => {
		dateArray.push({ value: element.value, text: element.text })
		// if (element.value === value) {
		// element.selected = true
		// }
	})
	ddlDateRange.innerHTML = ''
	dateArray.forEach((elem) => {
		const opt = document.createElement('option')
		opt.value = elem.value
		opt.innerHTML = elem.text
		if (value === elem.value) {
			opt.selected = true
		}
		ddlDateRange.appendChild(opt)
	})
}
function dateCheck() {
	const dateFrom = document.getElementById('DateFrom') as HTMLInputElement
	let sDateFrom: string = dateFrom.value.toString()
	const dateTo = document.getElementById('DateTo') as HTMLInputElement
	let sDateTo: string = dateTo.value.toString()
	const aDateFrom = sDateFrom.split('/')
	sDateFrom = `${aDateFrom[2]}-${aDateFrom[1]}-${aDateFrom[0]}`
	const dDateFrom: Date = new Date(sDateFrom)
	const dDateFromFinal: Date = new Date(
		dDateFrom.getFullYear(),
		dDateFrom.getMonth(),
		dDateFrom.getDate()
	)
	const aDateTo = sDateTo.split('/')
	sDateTo = `${aDateTo[2]}-${aDateTo[1]}-${aDateTo[0]}`
	const dDateTo: Date = new Date(sDateTo)
	const dDateToFinal: Date = new Date(dDateTo.getFullYear(), dDateTo.getMonth(), dDateTo.getDate())

	const d: Date = new Date()
	const day = d.getDay()
	const diff = d.getDate() - day + (day === 0 ? -6 : 1) // adjust when day is sunday
	const dateYesterday: Date = new Date(
		addDays(new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate()), -1)
	)
	const dateFirstOfWeek: Date = new Date(
		new Date(
			dDateFromFinal.getFullYear(),
			dDateFromFinal.getMonth(),
			dDateFromFinal.getDate()
		).setDate(diff - 7)
	)
	const dateLastOfWeek: Date = new Date(
		new Date(
			dDateFromFinal.getFullYear(),
			dDateFromFinal.getMonth(),
			dDateFromFinal.getDate()
		).setDate(diff - 1)
	)

	const ddlDateRange = document.querySelector('.ddlDateRange') as HTMLSelectElement

	if (
		dDateFromFinal.toString()
			=== new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate()).toString()
		&& dDateToFinal.toString()
			=== new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate()).toString()
	) {
		// Today
		if (ddlDateRange != null) {
			setDateRangeOption(ddlDateRange, dateFrom.value)
		}
	} else if (
		dDateFromFinal.toString() === dateYesterday.toString()
		&& dDateToFinal.toString() === dateYesterday.toString()
	) {
		// Yesterday
		setDateRangeOption(ddlDateRange, dateYesterday.toLocaleDateString('en-GB'))
	} else if (
		dDateFromFinal.toString()
			=== new Date(new Date().getFullYear(), new Date().getMonth(), 1).toString()
		&& dDateToFinal.toString()
			=== new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0).toString()
	) {
		setDateRangeOption(ddlDateRange, dDateFromFinal.toLocaleDateString('en-GB'))
	} else if (
		dDateFromFinal.toString() === dateFirstOfWeek.toString()
		&& dDateToFinal.toString() === dateLastOfWeek.toString()
	) {
		// Last Week
		setDateRangeOption(ddlDateRange, dDateFromFinal.toLocaleDateString('en-GB'))
	} else if (
		dDateFromFinal.toString() === new Date(dDateFromFinal.setDate(diff)).toString()
		&& dDateFromFinal !== dDateToFinal
	) {
		// This Week
		setDateRangeOption(ddlDateRange, dDateToFinal.toLocaleDateString('en-GB'))
	} else {
		// Custom
		setDateRangeOption(ddlDateRange, '01/01/1900')
	}
	datepicker()
}

const logTableLoad = () => {
	const date = new Date()
	const table = document.getElementById('logTable') as HTMLTableElement
	if (table != null) {
		const elements = table.getElementsByTagName('tr')
		for (let i = 0; i < elements.length; i += 1) {
			if (elements[i].firstElementChild!.tagName === 'TD') {
				const contactsLogDate: Date = new Date(
					moment(
						elements[i].cells[0].innerHTML.toString(),
						'DD/MM/YYYY HH:mm'
					).toDate()
				)
				const btnViewLog = elements[i].querySelector(
					'.btnViewLog'
				) as HTMLFormElement
				const diff = Math.abs(date.getTime() - contactsLogDate.getTime())
				const diffDays = Math.ceil(diff / (1000 * 3600 * 24))
				if (diffDays > 7) {
					btnViewLog.classList.add('d-none')
				}
			}
		}
	}
	popoverInitialise()
	dateCheck()
}
const logTableInitialise = () => {
	const logTable = new JSTable('#logTable', {
		columns: [
			{
				select: 0,
				render(cell) {
					const data = cell.innerHTML
					let dataarray: string[] = data.split('>')
					dataarray = dataarray[1].split('<')
					if (dataarray[0] !== '') {
						const isoDate = new Date(dataarray[0]).toISOString()
						if (dayjs(isoDate).isValid()) {
							return dayjs(isoDate).format('DD/MM/YYYY HH:mm')
						}
						return ''
					}
				}
			},
			{ select: [1, 2, 3, 4, 5, 6, 7, 8], sortable: false }
		],
		labels: {
			loading: 'Loading...',
			noRows: 'No data available in table'
		}
	})
	logTable.on('update', () => {
		logTableLoad()
	})
}
const logTablePartialInitialise = () => {
	const hidLogTable = document.getElementById('hidLogTable') as HTMLFormElement
	const dateFrom = document.getElementById('DateFrom') as HTMLInputElement
	const dateTo = document.getElementById('DateTo') as HTMLInputElement
	const palomaEmployeeID = document.getElementById(
		'ddlPalomaEmployee'
	) as HTMLSelectElement
	fetch(
		`${hidLogTable.value.toString()
		}?DateFrom=${encodeURIComponent(
			dateFrom.value.toString()
		)}&DateTo=${encodeURIComponent(
			dateTo.value.toString()
		)}&PalomaEmployeeID=${encodeURIComponent(
			palomaEmployeeID.value.toString()
		)}`,
		{
			method: 'POST'
		}
	)
		.then((response) => response.text())
		.then((result) => {
			const logTablePartialContent = document.querySelector(
				'.LogTablePartialContent'
			) as HTMLFormElement
			logTablePartialContent.innerHTML = result
			logTableInitialise()
			setTimeout(() => {}, 500)
		})
		.catch((ex) => {
			alert(`Failed to retrieve logs.${ex}`)
		})
}
const setMonthDate = (date: Date) => {
	const dateMonth = date.getMonth() + 1 < 10 ? `0${date.getMonth() + 1}` : date.getMonth() + 1
	const dateDate = date.getDate() < 10 ? `0${date.getDate()}` : date.getDate()
	return { dateDate, dateMonth }
}
const dateFormatter = (date: Date) => `${setMonthDate(date).dateDate}/${setMonthDate(date).dateMonth}/${date.getFullYear()}`
const setToday = (dateFromDiv: HTMLFormElement, DateFrom: string, dateToDiv: HTMLFormElement) => {
	dateFromDiv.value = DateFrom
	dateToDiv.value = DateFrom
}
const setLastWeek = (dateFromDiv: HTMLFormElement, dateToDiv: HTMLFormElement) => {
	const lastWeekToday = new Date()
	const day = lastWeekToday.getDay() || 7
	if (day !== 1) {
		lastWeekToday.setHours(-24 * (day - 1))
	}
	lastWeekToday.setDate(lastWeekToday.getDate() + -7)
	const lastWeekFormattedFromDate = dateFormatter(lastWeekToday)
	dateFromDiv.value = lastWeekFormattedFromDate

	const lastWeekEndOfWeek = new Date()
	const t = lastWeekToday.getDate() + 6
	const d = new Date(lastWeekToday.getFullYear(), lastWeekToday.getMonth() + 1, 0)
	const remainder = t % d.getDate()
	lastWeekEndOfWeek.setDate(remainder)
	const lastWeekFormattedToDate = dateFormatter(lastWeekEndOfWeek)
	dateToDiv.value = lastWeekFormattedToDate
}
const setThisWeek = (dateFromDiv: HTMLFormElement, dateToDiv: HTMLFormElement) => {
	const today = new Date()
	const day = today.getDay() || 7
	if (day !== 1) {
		today.setHours(-24 * (day - 1))
	}
	const thisWeekFormattedFromDate = dateFormatter(today)
	dateFromDiv.value = thisWeekFormattedFromDate

	const endOfWeek = new Date()
	endOfWeek.setDate(today.getDate() + 6)
	const thisWeekFormattedToDate = dateFormatter(endOfWeek)
	dateToDiv.value = thisWeekFormattedToDate
}
const setCurrentMonth = (dateFromDiv: HTMLFormElement, dateToDiv: HTMLFormElement) => {
	const date = new Date()
	const firstDay = new Date(date.getFullYear(), date.getMonth(), 1)
	const lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0)
	const formattedFromDate = dateFormatter(firstDay)
	const formattedToDate = dateFormatter(lastDay)
	dateFromDiv.value = formattedFromDate
	dateToDiv.value = formattedToDate
}
const setYesterday = (
	dDateFrom: Date,
	dateToDiv: HTMLFormElement,
	dateFromDiv: HTMLFormElement
) => {
	const newDateFrom = new Date(dDateFrom)
	const formattedDate = dateFormatter(newDateFrom)
	dateToDiv.value = formattedDate
	dateFromDiv.value = formattedDate
}
function dateRangeEventListener() {
	const ddlDateRange = document.getElementById('ddlDateRange') as HTMLSelectElement
	ddlDateRange.addEventListener('change', () => {
		const dateFrom: string = ddlDateRange.value.toString()
		let dateFromText = ''
		for (let i = 0; i < ddlDateRange.length; i += 1) {
			const recipient = ddlDateRange[i] as HTMLOptionElement
			if (recipient.selected) {
				dateFromText = recipient.text
			}
		}
		if (dateFromText !== 'Custom') {
			setDateRange(dateFrom, dateFromText)
		}
	})
}
function setDateRange(DateFrom: string, DateFromText: string) {
	const aDateFrom = DateFrom.split('/')
	const dDateFrom: Date = new Date(
		parseInt(aDateFrom[2], 10),
		parseInt(aDateFrom[1], 10) - 1,
		parseInt(aDateFrom[0], 10)
	)
	const dateFromDiv = document.querySelector('.DateFrom') as HTMLFormElement
	const dateToDiv = document.querySelector('.DateTo') as HTMLFormElement
	if (DateFromText === 'Today') {
		setToday(dateFromDiv, DateFrom, dateToDiv)
	} else if (DateFromText === 'Yesterday') {
		setYesterday(dDateFrom, dateToDiv, dateFromDiv)
	} else if (DateFromText === 'Current Month') {
		setCurrentMonth(dateFromDiv, dateToDiv)
	} else if (DateFromText === 'This week') {
		setThisWeek(dateFromDiv, dateToDiv)
	} else {
		setLastWeek(dateFromDiv, dateToDiv)
	}
	dateRangeEventListener()
}
class ddlDateRangeOption {
	value: string

	text: string
}
const initialise = () => {
	logTablePartialInitialise()
	dateCheck()
	ddlGenericInitialise()
	const addLogDiv = document.querySelector('.AddLog') as HTMLFormElement
	const addLog = new Modal(addLogDiv, {
		backdrop: true,
		keyboard: true
	})
	const btnCancel = document.querySelector('.btnCancel') as HTMLFormElement
	if (btnCancel != null) {
		btnCancel.addEventListener('click', () => {
			addLog.hide()
		})
	}
	const closeAddLog = document.querySelector('.closeAddLog') as HTMLFormElement
	if (closeAddLog != null) {
		closeAddLog.addEventListener('click', () => {
			addLog.hide()
		})
	}
	const clientSearchDiv = document.querySelector('.ClientSearch') as HTMLFormElement
	const clientSearch = new Modal(clientSearchDiv, {
		backdrop: true,
		keyboard: true
	})
	const btnCancelSearch = document.querySelector('.btnCancelSearch') as HTMLFormElement
	if (btnCancelSearch != null) {
		btnCancelSearch.addEventListener('click', () => {
			clientSearch.hide()
		})
	}
	const closeSearch = document.querySelector('.closeSearch') as HTMLFormElement
	if (closeSearch != null) {
		closeSearch.addEventListener('click', () => {
			clientSearch.hide()
		})
	}
	dateRangeEventListener()
	const dateFrom = document.getElementById('DateFrom') as HTMLFormElement
	const dateTo = document.getElementById('DateTo') as HTMLFormElement

	const dateDiffCheck = () => {
		const aDateTo = dateTo.value.split('/')
		const sDateTo = `${aDateTo[2]}-${aDateTo[1]}-${aDateTo[0]}`
		const dDateTo = new Date(sDateTo)
		const aDateFrom = dateFrom.value.split('/')
		const sDateFrom = `${aDateFrom[2]}-${aDateFrom[1]}-${aDateFrom[0]}`
		const dDateFrom = new Date(sDateFrom)
		const diff = Math.floor(
			(Date.UTC(dDateTo.getFullYear(), dDateTo.getMonth(), dDateTo.getDate())
      - Date.UTC(dDateFrom.getFullYear(), dDateFrom.getMonth(), dDateFrom.getDate()))
      / (1000 * 60 * 60 * 24)
		)
		if (diff > 31) {
			const dateRangeExceedDiv = document.getElementById('DateRangeExceed') as HTMLFormElement
			if (dateRangeExceedDiv != null) {
				const dateRangeExceed = new Modal(dateRangeExceedDiv, {
					backdrop: true,
					keyboard: true
				})
				dateRangeExceed.show()
				dateTo.value = dateFrom.value.toString()
			}
		}
		if (diff < 0) {
			const dateOrderDiv = document.getElementById('DateOrder') as HTMLFormElement
			if (dateOrderDiv != null) {
				const dateOrder = new Modal(dateOrderDiv, {
					backdrop: true,
					keyboard: true
				})
				dateOrder.show()
				dateTo.value = dateFrom.value.toString()
			}
			dateTo.value = dateFrom.value.toString()
		}
	}
	if (dateFrom != null) {
		dateFrom.addEventListener('change', () => {
			dateDiffCheck()
		})
	}
	if (dateTo != null) {
		dateTo.addEventListener('change', () => {
			dateDiffCheck()
		})
	}
	const btnSearch = document.querySelector('.btnSearch') as HTMLButtonElement
	if (btnSearch != null) {
		btnSearch.addEventListener('click', () => {
			logTablePartialInitialise()
		})
	}
}
window.addEventListener('load', () => {
	initialise()
})
